<div class='surface-200 py-3 px-0 md:px-8 pt-8 relative bg-color w-full max-width mx-auto'>

  <div class='curve mx-0'>
    <svg data-name='curve for footer' viewBox='0 0 1200 120' preserveAspectRatio='none'>
      <path d='M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z' class='shape-fill'></path>
    </svg>
  </div>

  <div class='mx-6 md:px-4 lg:px-8 md:mx-2 pt-8'>
    <div class='col-12 my-4 px-0'>
      <img src='assets/layout/images/iPensii-white.svg' alt='iPensii Logo White' class='logo-height'>
    </div>

    <div class='grid justify-content-between md:flex-column lg:flex-row'>
      <div class='col-12 grid text-left justify-content-between'>
        @for (footerMenuItem of footerMenuItems; track footerMenuItem.category) {
          <div class='col-12 md:col-2'>
            <p class='font-medium text-xl line-height-3 mb-3 font-bold text-color-white'>
              {{ footerMenuItem.category }}
            </p>
            @for (item of footerMenuItem.items; track item.label) {
              <a class='line-height-3 text-xl block cursor-pointer mb-2 text-800 text-color-white-semitransparent'
                 [href]='item.url' [target]='item.target'>
                <i [class]='item.icon'></i> {{ item.label }}
              </a>
            }
          </div>
        }
      </div>

      <div class='col-12 font-size-sm'>
        <div class='grid'>
          <div
            class='md:flex md:justify-content-between align-items-center col-12 lg:col-6 text-color-white text-left '>
            <div><img src='assets/layout/images/ASF.svg' alt='ASF Logo White' width='128'
                      class='mx-8 mb-4 md:mx-0 md:mb-0 md:pr-3'></div>
            <div>{{ authorizationText }}</div>
          </div>
          <div class='col-12 lg:col-6 text-color-white text-right white-space-pre-wrap'>
            {{ ipensiiDetailText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
